export default __webpack_public_path__ + "static/media/fatos3.672d900c.jpg";